module.exports = __webpack_public_path__ + "img/signature.6fb4408c.png";